import {
  CreationTaxIdentifierSchema,
  RedactedTaxIdentifierSchema,
} from "@redotech/redo-fulfillment-customs-common/customs";
import * as z from "zod";

export const createTaxIdentifier = {
  name: "createTaxIdentifier" as const,
  input: z.object({ identifier: CreationTaxIdentifierSchema }),
  output: z.object({ identifiers: z.array(RedactedTaxIdentifierSchema) }),
};
